<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<path class="bright" d="M6,0L0,6h3v6h6V6h3L6,0z M8,5v6H4V5H2.41L6,1.41L9.59,5H8z" />
</svg>
</template>